export default __webpack_public_path__ + "static/media/reg_hold.762f93d9.png";